import { useEffect } from 'react';

/**
 * SEO Component for dynamic meta tags
 * Updates document head with page-specific meta information
 */
export const SEO = ({ 
  title, 
  description, 
  canonical,
  type = 'website',
  noindex = false 
}) => {
  const siteName = 'BMI Calc Hub';
  const baseUrl = 'https://bmicalchub.com';
  
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} | Free BMI Calculator for Athletes & Fitness Enthusiasts`;
  const fullCanonical = canonical ? `${baseUrl}${canonical}` : baseUrl;

  useEffect(() => {
    // Update title
    document.title = fullTitle;
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription && description) {
      metaDescription.setAttribute('content', description);
    }
    
    // Update meta title
    const metaTitle = document.querySelector('meta[name="title"]');
    if (metaTitle) {
      metaTitle.setAttribute('content', fullTitle);
    }
    
    // Update canonical
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', fullCanonical);
    }
    
    // Update Open Graph tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    const ogDescription = document.querySelector('meta[property="og:description"]');
    const ogUrl = document.querySelector('meta[property="og:url"]');
    const ogType = document.querySelector('meta[property="og:type"]');
    
    if (ogTitle) ogTitle.setAttribute('content', fullTitle);
    if (ogDescription && description) ogDescription.setAttribute('content', description);
    if (ogUrl) ogUrl.setAttribute('content', fullCanonical);
    if (ogType) ogType.setAttribute('content', type);
    
    // Update Twitter tags
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    const twitterDescription = document.querySelector('meta[name="twitter:description"]');
    const twitterUrl = document.querySelector('meta[name="twitter:url"]');
    
    if (twitterTitle) twitterTitle.setAttribute('content', fullTitle);
    if (twitterDescription && description) twitterDescription.setAttribute('content', description);
    if (twitterUrl) twitterUrl.setAttribute('content', fullCanonical);
    
    // Handle noindex
    let robotsMeta = document.querySelector('meta[name="robots"]');
    if (robotsMeta) {
      robotsMeta.setAttribute('content', noindex ? 'noindex, nofollow' : 'index, follow');
    }
    
    // Cleanup - restore defaults when component unmounts
    return () => {
      document.title = `${siteName} | Free BMI Calculator for Athletes & Fitness Enthusiasts`;
    };
  }, [fullTitle, description, fullCanonical, type, noindex]);

  return null; // This component doesn't render anything
};

export default SEO;
